import React from "react";

const initState = {
  page: 1,
  limit: 10,
  total: 0,
};

const usePaginaton = (customState = initState) => {
  const [paginationState, setPaginationState] =
    React.useState<any>(customState);

  return [paginationState, (data: any) => setPaginationState(data)];
};

export default usePaginaton;
